export default "__VITE_ASSET__nYz9Vohi__"